import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import TopMenu from './TopMenu';
import Sparameter from './sparameter/index';
import Effective from './effective';
import Decap from './decap/index';
import DecapGroup from './decapGroup/index';
import {
  changeResultKey,
  backToImpedance,
  getHistorys,
  saveHistory,
  deleteHistory,
  saveCompare,
  getImports,
  deleteImport,
  getCompares
} from '../../store/result/Impedance/action';
import Transient from './transient';
import PlaneCapacitance from './planeCapacitance';
import { getImpedanceJson } from '../../../../services/Cascade/Impedance';

class ImpResultContent extends PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      transientRes: null,
      transientMap: {},
      powerDisc: {}
    }

    this.impedanceResultContent = {}
  }

  componentDidMount = async () => {
    const { verificationId } = this.props
    this.impedanceResultContent = await getImpedanceJson(verificationId);
    this.props.getHistorys();
    this.props.getImports();
    this.props.getCompares();
  }

  componentUpdate = async (prevProps) => {
    if (this.props.verificationId && prevProps.verificationId !== this.props.verificationId) {
      this.impedanceResultContent = await getImpedanceJson(this.props.verificationId);
      this.props.getHistorys()
      this.props.getImports()
      this.props.getCompares()
    }
  }

  setTransientRes = (res, map, powerDisc) => {
    this.setState({
      transientRes: res,
      transientMap: map,
      powerDisc
    })
  }

  changeSelectKey = (key) => {
    if (key === 'setup') {
      this.props.backToImpedance()
    } else {
      this.props.changeResultKey(key)
    }
  }

  getResultRender = (key) => {
    switch (key) {
      case 'effective':
        return this.effectiveRender();
      case 'impedance':
      default:
        return this.sparameterRender();
      case "decap":
        return this.decapRender()
      case "decapGroup":
        return this.decapGroupRender()
      case "transient":
        return this.transientRender()
      case "planeCapacitance":
        return this.planeCapacitanceRender()
    }
  }

  sparameterRender = () => {
    const { data, verificationId, historys, updateHistory, imports, updateImports, resultExist, compares, updateCompare, target } = this.props;
    const exist = resultExist ? resultExist.exist : false;
    return <Sparameter
      ImpedanceContent={data}
      target={target}
      id={verificationId}
      historys={historys}
      imports={imports}
      updateHistory={updateHistory}
      updateImports={updateImports}
      deleteHistory={this.props.deleteHistory}
      getImports={this.props.getImports}
      deleteImport={this.props.deleteImport}
      compares={compares}
      updateCompare={updateCompare}
      updateCompareList={this.props.saveCompare}
      exist={exist}
      impedanceResultContent={this.impedanceResultContent}
    />
  }

  effectiveRender = () => {
    const { verificationId, historys, updateHistory, compares, updateCompare } = this.props;
    return <Effective
      id={verificationId}
      historys={historys}
      updateHistory={updateHistory}
      deleteHistory={this.props.deleteHistory}
      compares={compares}
      updateCompare={updateCompare}
      updateCompareList={this.props.saveCompare}
      impedanceResultContent={this.impedanceResultContent}
    />
  }

  decapRender = () => {
    const { verificationId, historys, updateHistory } = this.props
    return <Decap
      id={verificationId}
      historys={historys}
      updateHistory={updateHistory}
      deleteHistory={this.props.deleteHistory}
      impedanceResultContent={this.impedanceResultContent}
    />
  }

  decapGroupRender = () => {
    const { verificationId, historys, updateHistory } = this.props
    return <DecapGroup
      id={verificationId}
      historys={historys}
      updateHistory={updateHistory}
      deleteHistory={this.props.deleteHistory}
      impedanceResultContent={this.impedanceResultContent}
    />
  }

  transientRender = () => {
    const { verificationId, data } = this.props
    const { transientRes, transientMap, powerDisc } = this.state
    return <Transient
      id={verificationId}
      ImpedanceContent={data}
      impedanceResultContent={this.impedanceResultContent}
      transientRes={transientRes}
      transientMap={transientMap}
      powerDisc={powerDisc}
      setTransientRes={this.setTransientRes}
    />
  }

  planeCapacitanceRender = () => {
    const { verificationId, data } = this.props
    return <PlaneCapacitance
      id={verificationId}
      ImpedanceContent={data}
      impedanceResultContent={this.impedanceResultContent}
    />
  }

  render() {
    const { resultKey, layoutLeftWidth, leftWidth } = this.props;
    return <div className="cascade-result-impedance">
      {TopMenu({
        selectedKey: resultKey,
        changeResultType: this.changeSelectKey,
        layoutLeftWidth,
        leftWidth,
        saveHistory: this.props.saveHistory
      })}
      <div className="cascade-result-impedance-result-content">
        {this.getResultRender(resultKey)}
      </div>
    </div>
  }
}

const mapState = (state) => {
  const { ImpedanceResult: { resultKey, historys, imports, updateHistory, updateImports, compares, updateCompare }, Impedance: { data, verificationId, resultExist, target }, project: { openProjectId } } = state.CascadeReducer
  return {
    resultKey,
    data,
    verificationId,
    openProjectId,
    historys,
    imports,
    updateHistory,
    updateImports,
    resultExist,
    compares,
    updateCompare,
    target
  }
}

const mapDispatch = (dispatch) => ({
  changeResultKey(key) {
    dispatch(changeResultKey(key))
  },
  backToImpedance() {
    dispatch(backToImpedance())
  },
  getHistorys() {
    dispatch(getHistorys())
  },
  saveHistory(name) {
    dispatch(saveHistory(name))
  },
  deleteHistory(id) {
    dispatch(deleteHistory(id))
  },
  saveCompare(compares) {
    dispatch(saveCompare(compares))
  },
  getImports() {
    dispatch(getImports())
  },
  deleteImport(id) {
    dispatch(deleteImport(id))
  },
  getCompares() {
    dispatch(getCompares())
  }
})

export default connect(mapState, mapDispatch)(ImpResultContent);